import _ from 'lodash';
import Alert from "react-s-alert";
import {I18nUtils} from "../../../i18n/I18nUtils";
import RemoveRequest from "../ws/RemoveRequest";
import {PsRoutes} from "../../shared/routing/Routes";
import {push} from "react-router-redux";

export const REMOVE_LOADING  = 'remove-loading';
export const REMOVE_ERROR  = 'remove-error';
export const REMOVE_UPDATE  = 'remove-update';

export const REMOVE_CHECK_COMPANY = 'remove-check-company';
export const REMOVE_CHECK_WORKER = 'remove-check-worker';
export const REMOVE_CHECK_MACHINE = 'remove-check-machine';
export const REMOVE_INIT_STATE = 'remove-init-state';

// ACTIONS

// Companies
export const checkCompany = (company, checked) => (dispatch) => {
  dispatch({
    type: REMOVE_CHECK_COMPANY,
    payload: company,
    checked: checked,
  });
};
export const checkCompanies = (companies, checked) => (dispatch) => {
  _.forEach(companies, (company) => {
    dispatch({
      type: REMOVE_CHECK_COMPANY,
      payload: company,
      checked: checked,
    });
  });
};

// Workers
export const checkWorker = (worker, checked) => (dispatch) => {
  dispatch({
    type: REMOVE_CHECK_WORKER,
    payload: worker,
    checked: checked,
  });
};
export const checkWorkers = (workers, checked) => (dispatch) => {
  workers.forEach((worker) => {
    dispatch({
      type: REMOVE_CHECK_WORKER,
      payload: worker,
      checked: checked,
    });
  });
};

// Machine
export const checkMachine = (machine, checked) => (dispatch) => {
  dispatch({
    type: REMOVE_CHECK_MACHINE,
    payload: machine,
    checked: checked,
  });
};
export const checkMachines = (machines, checked) => (dispatch) => {
  _.forEach(machines, (machine) => {
    dispatch({
      type: REMOVE_CHECK_MACHINE,
      payload: machine,
      checked: checked,
    });
  });
};


export const removeWithoutCommit = (companyIds, workersIds, machinesIds) => (dispatch) => {

  new RemoveRequest(companyIds, workersIds, machinesIds)
    .onPreExecution(() => {
      dispatch({ type: REMOVE_LOADING, payload: true });
    })
    .onSuccess(data => {
      dispatch({ type: REMOVE_UPDATE, payload: data.data });
      dispatch(push(PsRoutes.MY_OUTSOURCES_PAPER_BIN_REMOVE_CONFIRM));
    })
    .onFail(error => {
      Alert.error(error || I18nUtils.tr('TR_REMOVE_ERROR'));
    })
    .onPostExecution(() => {
      dispatch({ type: REMOVE_LOADING, payload: false });
    })
    .execute();

};

export const remove = (companyIds, workersIds, machinesIds) => (dispatch) => {

  new RemoveRequest(companyIds, workersIds, machinesIds, true)
    .onPreExecution(() => {
      dispatch({ type: REMOVE_LOADING, payload: true });
    })
    .onSuccess(data => {
      Alert.success(I18nUtils.tr('TR_REMOVE_SUCCESS'));
      dispatch({ type: REMOVE_INIT_STATE });
      dispatch(push(PsRoutes.MY_OUTSOURCES));
    })
    .onFail(error => {
      Alert.error(error || I18nUtils.tr('TR_REMOVE_ERROR'));
    })
    .onPostExecution(() => {
      dispatch({ type: REMOVE_LOADING, payload: false });
    })
    .execute();

};




// WEBPACK FOOTER //
// ./src/app/remove/actions/removeActions.js